// Kindergarten & 1st Grade ("Big Kids") mode — Premium only.
export const BIGKIDS_CATEGORIES = [
  { key: "words_spell", title: "Words & Spelling", emoji: "🔡", color: "#0EA5E9", shadow: "rgba(2,132,199,1)", premium: true },
  { key: "math", title: "Math Adventures", emoji: "➗", color: "#EF4444", shadow: "rgba(185,28,28,1)", premium: true, quiz: true },
  { key: "geoworld", title: "Geography & World", emoji: "🌐", color: "#14B8A6", shadow: "rgba(13,148,136,1)", premium: true },
  { key: "foreign", title: "Foreign Language", emoji: "🗣️", color: "#F97316", shadow: "rgba(194,65,12,1)", premium: true },
];

// Learning-card categories: 3 levels x 12 items each.
export const BIGKIDS_LEVELS = {
  words_spell: [
    [
      { k: "frog", word: "Frog", emoji: "🐸", say: "Frog. F-R-O-G." },
      { k: "hand", word: "Hand", emoji: "✋", say: "Hand. H-A-N-D." },
      { k: "milk", word: "Milk", emoji: "🥛", say: "Milk. M-I-L-K." },
      { k: "jump", word: "Jump", emoji: "🦘", say: "Jump. J-U-M-P." },
      { k: "nest", word: "Nest", emoji: "🪺", say: "Nest. N-E-S-T." },
      { k: "lamp", word: "Lamp", emoji: "💡", say: "Lamp. L-A-M-P." },
      { k: "ring", word: "Ring", emoji: "💍", say: "Ring. R-I-N-G." },
      { k: "king", word: "King", emoji: "👑", say: "King. K-I-N-G." },
      { k: "sock", word: "Sock", emoji: "🧦", say: "Sock. S-O-C-K." },
      { k: "desk", word: "Desk", emoji: "🪑", say: "Desk. D-E-S-K." },
      { k: "gift", word: "Gift", emoji: "🎁", say: "Gift. G-I-F-T." },
      { k: "wind", word: "Wind", emoji: "🌬️", say: "Wind. W-I-N-D." },
    ],
    [
      { k: "cake", word: "Cake", emoji: "🍰", say: "Cake. C-A-K-E." },
      { k: "rain", word: "Rain", emoji: "🌧️", say: "Rain. R-A-I-N." },
      { k: "boat", word: "Boat", emoji: "⛵", say: "Boat. B-O-A-T." },
      { k: "kite", word: "Kite", emoji: "🪁", say: "Kite. K-I-T-E." },
      { k: "bike", word: "Bike", emoji: "🚲", say: "Bike. B-I-K-E." },
      { k: "rose", word: "Rose", emoji: "🌹", say: "Rose. R-O-S-E." },
      { k: "cube", word: "Cube", emoji: "🧊", say: "Cube. C-U-B-E." },
      { k: "nose", word: "Nose", emoji: "👃", say: "Nose. N-O-S-E." },
      { k: "game", word: "Game", emoji: "🎮", say: "Game. G-A-M-E." },
      { k: "home", word: "Home", emoji: "🏠", say: "Home. H-O-M-E." },
      { k: "tree", word: "Tree", emoji: "🌳", say: "Tree. T-R-E-E." },
      { k: "snail", word: "Snail", emoji: "🐌", say: "Snail. S-N-A-I-L." },
    ],
    [
      { k: "happy", word: "Happy", emoji: "😊", say: "Happy. H-A-P-P-Y." },
      { k: "water", word: "Water", emoji: "💧", say: "Water. W-A-T-E-R." },
      { k: "yellow", word: "Yellow", emoji: "🟡", say: "Yellow. Y-E-L-L-O-W." },
      { k: "rabbit", word: "Rabbit", emoji: "🐰", say: "Rabbit. R-A-B-B-I-T." },
      { k: "garden", word: "Garden", emoji: "🌷", say: "Garden. G-A-R-D-E-N." },
      { k: "pencil", word: "Pencil", emoji: "✏️", say: "Pencil. P-E-N-C-I-L." },
      { k: "monkey", word: "Monkey", emoji: "🐵", say: "Monkey. M-O-N-K-E-Y." },
      { k: "basket", word: "Basket", emoji: "🧺", say: "Basket. B-A-S-K-E-T." },
      { k: "window", word: "Window", emoji: "🪟", say: "Window. W-I-N-D-O-W." },
      { k: "summer", word: "Summer", emoji: "☀️", say: "Summer. S-U-M-M-E-R." },
      { k: "dragon", word: "Dragon", emoji: "🐉", say: "Dragon. D-R-A-G-O-N." },
      { k: "planet", word: "Planet", emoji: "🪐", say: "Planet. P-L-A-N-E-T." },
    ],
  ],
  geoworld: [
    [
      { k: "earth", word: "Earth", emoji: "🌍", say: "Earth is our home planet." },
      { k: "ocean", word: "Ocean", emoji: "🌊", say: "An ocean is a huge body of salt water." },
      { k: "continent", word: "Continent", emoji: "🗺️", say: "A continent is a very large piece of land." },
      { k: "country", word: "Country", emoji: "🏳️", say: "A country is a land with its own people and rules." },
      { k: "mountain", word: "Mountain", emoji: "⛰️", say: "A mountain is very tall land." },
      { k: "river", word: "River", emoji: "🏞️", say: "A river is flowing water." },
      { k: "desert", word: "Desert", emoji: "🏜️", say: "A desert is dry and sandy." },
      { k: "forest", word: "Forest", emoji: "🌲", say: "A forest is full of trees." },
      { k: "island", word: "Island", emoji: "🏝️", say: "An island has water all around it." },
      { k: "volcano", word: "Volcano", emoji: "🌋", say: "A volcano can erupt with lava." },
      { k: "northpole", word: "North Pole", emoji: "🧭", say: "The North Pole is the top of Earth." },
      { k: "map", word: "Map", emoji: "🗺️", say: "A map shows us where places are." },
    ],
    [
      { k: "france", word: "France", emoji: "🇫🇷", say: "France. Its capital is Paris." },
      { k: "japan", word: "Japan", emoji: "🇯🇵", say: "Japan. Its capital is Tokyo." },
      { k: "egypt", word: "Egypt", emoji: "🇪🇬", say: "Egypt. Its capital is Cairo." },
      { k: "brazil", word: "Brazil", emoji: "🇧🇷", say: "Brazil. Its capital is Brasília." },
      { k: "india", word: "India", emoji: "🇮🇳", say: "India. Its capital is New Delhi." },
      { k: "italy", word: "Italy", emoji: "🇮🇹", say: "Italy. Its capital is Rome." },
      { k: "china", word: "China", emoji: "🇨🇳", say: "China. Its capital is Beijing." },
      { k: "kenya", word: "Kenya", emoji: "🇰🇪", say: "Kenya. Its capital is Nairobi." },
      { k: "spain", word: "Spain", emoji: "🇪🇸", say: "Spain. Its capital is Madrid." },
      { k: "canada", word: "Canada", emoji: "🇨🇦", say: "Canada. Its capital is Ottawa." },
      { k: "mexico", word: "Mexico", emoji: "🇲🇽", say: "Mexico. Its capital is Mexico City." },
      { k: "usa", word: "USA", emoji: "🇺🇸", say: "The USA. Its capital is Washington." },
    ],
    [
      { k: "eiffel", word: "Eiffel Tower", emoji: "🗼", say: "The Eiffel Tower is in Paris, France." },
      { k: "pyramids", word: "Pyramids", emoji: "🔺", say: "The Pyramids are in Egypt." },
      { k: "liberty", word: "Statue of Liberty", emoji: "🗽", say: "The Statue of Liberty is in the USA." },
      { k: "greatwall", word: "Great Wall", emoji: "🧱", say: "The Great Wall is in China." },
      { k: "taj", word: "Taj Mahal", emoji: "🕌", say: "The Taj Mahal is in India." },
      { k: "bigben", word: "Big Ben", emoji: "🕰️", say: "Big Ben is a giant clock in London." },
      { k: "colosseum", word: "Colosseum", emoji: "🏛️", say: "The Colosseum is in Rome, Italy." },
      { k: "opera", word: "Sydney Opera", emoji: "🎭", say: "The Opera House is in Sydney, Australia." },
      { k: "fuji", word: "Mount Fuji", emoji: "🗻", say: "Mount Fuji is a mountain in Japan." },
      { k: "redeemer", word: "Christ Redeemer", emoji: "⛪", say: "This big statue is in Brazil." },
      { k: "windmill", word: "Windmill", emoji: "🌬️", say: "Windmills are famous in the Netherlands." },
      { k: "safari", word: "Safari", emoji: "🦁", say: "You can see wild animals on a safari in Africa." },
    ],
  ],
  foreign: [
    [
      { k: "rojo", word: "Rojo", emoji: "🔴", say: "Rojo means Red in Spanish!" },
      { k: "azul", word: "Azul", emoji: "🔵", say: "Azul means Blue in Spanish!" },
      { k: "verde", word: "Verde", emoji: "🟢", say: "Verde means Green in Spanish!" },
      { k: "pan", word: "Pan", emoji: "🍞", say: "Pan means Bread in Spanish!" },
      { k: "leche", word: "Leche", emoji: "🥛", say: "Leche means Milk in Spanish!" },
      { k: "agua", word: "Agua", emoji: "💧", say: "Agua means Water in Spanish!" },
      { k: "manzana", word: "Manzana", emoji: "🍎", say: "Manzana means Apple in Spanish!" },
      { k: "queso", word: "Queso", emoji: "🧀", say: "Queso means Cheese in Spanish!" },
      { k: "sol", word: "Sol", emoji: "☀️", say: "Sol means Sun in Spanish!" },
      { k: "luna", word: "Luna", emoji: "🌙", say: "Luna means Moon in Spanish!" },
      { k: "perro", word: "Perro", emoji: "🐶", say: "Perro means Dog in Spanish!" },
      { k: "gato", word: "Gato", emoji: "🐱", say: "Gato means Cat in Spanish!" },
    ],
    [
      { k: "bonjour", word: "Bonjour", emoji: "👋", say: "Bonjour means Hello in French!" },
      { k: "merci", word: "Merci", emoji: "🙏", say: "Merci means Thank you in French!" },
      { k: "oui", word: "Oui", emoji: "👍", say: "Oui means Yes in French!" },
      { k: "non", word: "Non", emoji: "👎", say: "Non means No in French!" },
      { k: "un", word: "Un", emoji: "1️⃣", say: "Un means One in French!" },
      { k: "deux", word: "Deux", emoji: "2️⃣", say: "Deux means Two in French!" },
      { k: "trois", word: "Trois", emoji: "3️⃣", say: "Trois means Three in French!" },
      { k: "chat", word: "Chat", emoji: "🐱", say: "Chat means Cat in French!" },
      { k: "chien", word: "Chien", emoji: "🐶", say: "Chien means Dog in French!" },
      { k: "rouge", word: "Rouge", emoji: "🔴", say: "Rouge means Red in French!" },
      { k: "eau", word: "Eau", emoji: "💧", say: "Eau means Water in French!" },
      { k: "ami", word: "Ami", emoji: "🧒", say: "Ami means Friend in French!" },
    ],
    [
      { k: "ciao", word: "Ciao", emoji: "👋", say: "Ciao means Hello in Italian!" },
      { k: "hallo", word: "Hallo", emoji: "👋", say: "Hallo means Hello in German!" },
      { k: "konnichiwa", word: "Konnichiwa", emoji: "🙇", say: "Konnichiwa means Hello in Japanese!" },
      { k: "namaste", word: "Namaste", emoji: "🙏", say: "Namaste means Hello in Hindi!" },
      { k: "salaam", word: "Salaam", emoji: "☮️", say: "Salaam means Peace and Hello in Arabic!" },
      { k: "nihao", word: "Ni Hao", emoji: "👋", say: "Ni Hao means Hello in Chinese!" },
      { k: "ola", word: "Olá", emoji: "👋", say: "Olá means Hello in Portuguese!" },
      { k: "privet", word: "Privet", emoji: "👋", say: "Privet means Hello in Russian!" },
      { k: "jambo", word: "Jambo", emoji: "👋", say: "Jambo means Hello in Swahili!" },
      { k: "annyeong", word: "Annyeong", emoji: "👋", say: "Annyeong means Hello in Korean!" },
      { k: "hola2", word: "Hola", emoji: "👋", say: "Hola means Hello in Spanish!" },
      { k: "bonjour2", word: "Bonjour", emoji: "👋", say: "Bonjour means Hello in French!" },
    ],
  ],
};

// Interactive quiz: each item has a question, correct answer, and options.
export const MATH_LEVELS = [
  [
    { k: "m1", q: "1 + 1 = ?", a: "2", options: ["2", "3", "4"] },
    { k: "m2", q: "2 + 2 = ?", a: "4", options: ["3", "4", "5"] },
    { k: "m3", q: "3 + 1 = ?", a: "4", options: ["4", "5", "6"] },
    { k: "m4", q: "2 + 3 = ?", a: "5", options: ["4", "5", "6"] },
    { k: "m5", q: "4 + 1 = ?", a: "5", options: ["5", "6", "7"] },
    { k: "m6", q: "3 + 3 = ?", a: "6", options: ["5", "6", "7"] },
    { k: "m7", q: "4 + 2 = ?", a: "6", options: ["6", "7", "8"] },
    { k: "m8", q: "5 + 2 = ?", a: "7", options: ["6", "7", "8"] },
    { k: "m9", q: "4 + 4 = ?", a: "8", options: ["7", "8", "9"] },
    { k: "m10", q: "5 + 4 = ?", a: "9", options: ["8", "9", "10"] },
    { k: "m11", q: "6 + 3 = ?", a: "9", options: ["8", "9", "10"] },
    { k: "m12", q: "5 + 5 = ?", a: "10", options: ["9", "10", "11"] },
  ],
  [
    { k: "s1", q: "4 - 1 = ?", a: "3", options: ["2", "3", "4"] },
    { k: "s2", q: "6 - 2 = ?", a: "4", options: ["3", "4", "5"] },
    { k: "s3", q: "7 - 3 = ?", a: "4", options: ["4", "5", "6"] },
    { k: "s4", q: "8 - 4 = ?", a: "4", options: ["3", "4", "5"] },
    { k: "s5", q: "9 - 5 = ?", a: "4", options: ["4", "5", "6"] },
    { k: "s6", q: "10 - 4 = ?", a: "6", options: ["5", "6", "7"] },
    { k: "s7", q: "10 - 7 = ?", a: "3", options: ["2", "3", "4"] },
    { k: "s8", q: "12 - 2 = ?", a: "10", options: ["9", "10", "11"] },
    { k: "s9", q: "11 - 5 = ?", a: "6", options: ["5", "6", "7"] },
    { k: "s10", q: "12 - 6 = ?", a: "6", options: ["6", "7", "8"] },
    { k: "s11", q: "10 - 8 = ?", a: "2", options: ["1", "2", "3"] },
    { k: "s12", q: "12 - 9 = ?", a: "3", options: ["2", "3", "4"] },
  ],
  [
    { k: "w1", q: "You have 2 apples and get 3 more. How many now?", a: "5", options: ["4", "5", "6"] },
    { k: "w2", q: "3 birds on a tree. 1 flies away. How many left?", a: "2", options: ["1", "2", "3"] },
    { k: "w3", q: "You have 4 candies and eat 1. How many left?", a: "3", options: ["2", "3", "4"] },
    { k: "w4", q: "2 red and 2 blue balloons. How many total?", a: "4", options: ["3", "4", "5"] },
    { k: "w5", q: "5 ducks in a pond. 2 more come. How many?", a: "7", options: ["6", "7", "8"] },
    { k: "w6", q: "You pick 6 flowers and give 2 away. How many left?", a: "4", options: ["3", "4", "5"] },
    { k: "w7", q: "3 kids each have 2 hands. How many hands?", a: "6", options: ["5", "6", "7"] },
    { k: "w8", q: "A box has 8 crayons. You use 3. How many left?", a: "5", options: ["4", "5", "6"] },
    { k: "w9", q: "You read 4 pages, then 4 more. How many pages?", a: "8", options: ["7", "8", "9"] },
    { k: "w10", q: "7 cookies. You share 3. How many left?", a: "4", options: ["3", "4", "5"] },
    { k: "w11", q: "2 cats have 4 legs each. How many legs?", a: "8", options: ["6", "8", "10"] },
    { k: "w12", q: "You have 10 stickers and lose 2. How many left?", a: "8", options: ["7", "8", "9"] },
  ],
];

export function getBKItems(category, level = 1) {
  if (category === "math") {
    const idx = Math.min(Math.max(level, 1), MATH_LEVELS.length) - 1;
    return MATH_LEVELS[idx];
  }
  const levels = BIGKIDS_LEVELS[category];
  if (!levels) return [];
  const idx = Math.min(Math.max(level, 1), levels.length) - 1;
  return levels[idx];
}

export function isBigKidsCategory(key) {
  return BIGKIDS_CATEGORIES.some((c) => c.key === key);
}
